import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import data_criticity from '../../data/criticity';
import data_priority from '../../data/priority';

import taskIcon from '../../images/icons/task.svg';
import appointmentIcon from '../../images/icons/appointment.svg';
import stopclockIcon from '../../images/icons/002-stopclock.svg';
import notesIcon from '../../images/icons/notes.svg';
import ringAnim from '../../images/anim/ring.svg';

const linkToTask = '/dashboard/task/';
const linkToAppointment = '/dashboard/appointment/';
const linkToReminder = '/dashboard/reminder/';
const linkToNote = '/dashboard/note/';

export default class MyPlanning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      filterTaskDate: false, // ASC
      filterAppointmentDate: false, // ASC
      filterReminderDate: false, // ASC
      filterNoteDate: true, // DESC
      filterTaskClosed: this.props.onEntity ? -1 : 0, // TODO -> remove when the build-in search will be implemented
      filterTaskCriticity: -1,
      filterTaskPriority: -1,
      filterAppointmentClosed: this.props.onEntity ? -1 : 0, // TODO -> remove when the build-in search will be implemented
      filterAppointmentCriticity: -1,
      filterReminderClosed: this.props.onEntity ? -1 : 0, // TODO -> remove when the build-in search will be implemented
      filterReminderCriticity: -1,
      selectedView: 1,
      entity: undefined,
      dataTask: undefined,
      dataAppointment: undefined,
      dataReminder: undefined,
      dataNote: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.seeMore = this.seeMore.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = parseInt(target.value, 10);
    const name = target.name;

    if (!this.props.onEntity) {
      // TODO -> remove when the build-in search will be implemented
      switch (name) {
        case 'filterTaskClosed':
          this.props.seeMore('task', true, value, -1, this.state.filterTaskCriticity, this.state.filterTaskPriority); // -1 cause no filter in state
          break;
        case 'filterTaskCriticity':
          this.props.seeMore('task', true, this.state.filterTaskClosed, -1, value, this.state.filterTaskPriority); // -1 cause no filter in state
          break;
        case 'filterTaskPriority':
          this.props.seeMore('task', true, this.state.filterTaskClosed, -1, this.state.filterTaskCriticity, value); // -1 cause no filter in state
          break;
        case 'filterAppointmentClosed':
          this.props.seeMore('appointment', true, value, -1, this.state.filterAppointmentCriticity); // -1 cause no filter in state
          break;
        case 'filterAppointmentCriticity':
          this.props.seeMore('appointment', true, this.state.filterAppointmentClosed, -1, value); // -1 cause no filter in state
          break;
        case 'filterReminderClosed':
          this.props.seeMore('reminder', true, value, -1, this.state.filterAppointmentCriticity); // -1 cause no filter in state
          break;
        case 'filterReminderCriticity':
          this.props.seeMore('reminder', true, this.state.filterAppointmentClosed, -1, value); // -1 cause no filter in state
          break;
      }
    }

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {}

  seeMore(type) {
    switch (type) {
      case 'task':
        this.props.seeMore(
          type,
          false,
          this.state.filterTaskClosed,
          -1,
          this.state.filterTaskCriticity,
          this.state.filterTaskPriority
        ); // -1 cause no filter in state
        break;
      case 'appointment':
        this.props.seeMore(type, false, this.state.filterAppointmentClosed, -1, this.state.filterAppointmentCriticity); // -1 cause no filter in state
        break;
      case 'reminder':
        this.props.seeMore(type, false, this.state.filterReminderClosed, -1, this.state.filterReminderCriticity); // -1 cause no filter in state
        break;
      case 'note':
        this.props.seeMore(type, false);
        break;
    }
  }

  isCollaborativePositive(type, dateTrigger, closed, state = null) {
    let res = false;
    switch (type) {
      case 'task': // Ongoing
        res = !closed && state === 2;
        break;
      case 'appointment': // coming in less than 48 hours
        res = !closed && moment(dateTrigger) <= moment().add(48, 'hours');
        break;
      case 'reminder': // Ongoing
        res = !closed && state === 2;
        break;
    }
    return res;
  }

  isCollaborativeNegative(type, dateTrigger, closed, state = null) {
    let res = false;
    switch (type) {
      case 'task': // coming in less than 48 hours
        res = !closed && moment(dateTrigger) <= moment().add(48, 'hours') && state === 1;
        break;
      case 'appointment': // Outdated
        res = !closed && moment(dateTrigger) <= moment();
        break;
      case 'reminder': // triggered
        res = !closed && moment(dateTrigger) <= moment() && state === 1;
        break;
    }
    return res;
  }

  toggleDateFiltering(type) {
    this.setState({
      // reset filter
      [type]: !this.state[type],
    });
  }

  filterTasks = (tasks = []) => {
    if (this.props.onEntity) {
      let filteredTasks = [...tasks];
      if (this.state.filterTaskClosed !== -1) {
        const closed = this.state.filterTaskClosed === 1;
        filteredTasks = filteredTasks.filter((task) => task.closed === closed);
      }

      if (this.state.filterTaskCriticity !== -1) {
        filteredTasks = filteredTasks.filter((task) => task.criticity === this.state.filterTaskCriticity);
      }

      if (this.state.filterTaskPriority !== -1) {
        filteredTasks = filteredTasks.filter((task) => task.priority === this.state.filterTaskPriority);
      }

      return filteredTasks;
    }

    return tasks;
  };

  filterReminders = (reminders = []) => {
    if (this.props.onEntity) {
      let filteredReminders = [...reminders];
      if (this.state.filterReminderClosed !== -1) {
        const closed = this.state.filterReminderClosed === 1;
        filteredReminders = filteredReminders.filter((reminder) => reminder.closed === closed);
      }

      if (this.state.filterReminderCriticity !== -1) {
        filteredReminders = filteredReminders.filter(
          (reminder) => reminder.criticity === this.state.filterReminderCriticity
        );
      }

      return filteredReminders;
    }

    return reminders;
  };

  filterAppointments = (appointments = []) => {
    if (this.props.onEntity) {
      let filteredAppointments = [...appointments];
      if (this.state.filterAppointmentClosed !== -1) {
        const closed = this.state.filterAppointmentClosed === 1;
        filteredAppointments = filteredAppointments.filter((appointment) => appointment.closed === closed);
      }

      if (this.state.filterAppointmentCriticity !== -1) {
        filteredAppointments = filteredAppointments.filter(
          (appointment) => appointment.criticity === this.state.filterAppointmentCriticity
        );
      }

      return filteredAppointments;
    }

    return appointments;
  };

  render() {
    const { dataTask } = this.props;
    const { dataAppointment } = this.props;
    const { dataReminder } = this.props;
    const { dataNote } = this.props;

    let noTask = this.props.dataTask && this.props.dataTask.length === 0 ? <span>Aucune tâche.</span> : '';
    let noAppointment =
      this.props.dataAppointment && this.props.dataAppointment.length === 0 ? <span>Aucun rendez-vous.</span> : '';
    let noReminder = this.props.dataReminder && this.props.dataReminder.length === 0 ? <span>Aucun rappel.</span> : '';
    let noNote = this.props.dataNote && this.props.dataNote.length === 0 ? <span>Aucune note.</span> : '';

    const styles = {
      image: {
        width: '15px',
      },
    };

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Tâches';
        break;
      case 2:
        viewName = 'Rendez-vous';
        break;
      case 3:
        viewName = 'Rappels';
        break;
      case 4:
        viewName = 'Notes';
        break;
    }

    return (
      <div className={this.props.onEntity && 'my-planning-entity'}>
        <div className='timeline menu'>
          <div className='timeline-flex'>
            <div
              onClick={(newStep) => this.switchStep(1)}
              className={'prep-step-number ' + (this.state.selectedView === 1 ? 'selected' : '')}
            >
              <img style={styles.image} src={taskIcon} alt='' />
            </div>
            <div
              onClick={(newStep) => this.switchStep(2)}
              className={'prep-step-number ' + (this.state.selectedView === 2 ? 'selected' : '')}
            >
              <img style={styles.image} src={appointmentIcon} alt='' />
            </div>
            <div
              onClick={(newStep) => this.switchStep(3)}
              className={'prep-step-number ' + (this.state.selectedView === 3 ? 'selected' : '')}
            >
              <img style={styles.image} src={stopclockIcon} alt='' />
            </div>
            <div
              onClick={(newStep) => this.switchStep(4)}
              className={'prep-step-number ' + (this.state.selectedView === 4 ? 'selected' : '')}
            >
              <img style={styles.image} src={notesIcon} alt='' />
            </div>
          </div>
        </div>
        <div className='timeline-step-name'>
          <h3>{viewName}</h3>
        </div>
        {this.state.selectedView === 1 && (
          <div>
            <div className='helper helper-panel-legend'>
              <span className='helper-label-legend lvl2'>À traiter</span>
              <span className='helper-label-legend lvl1'>En cours</span>
            </div>
            <br />

            <table className='table'>
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>
                    <select
                      name='filterTaskClosed'
                      value={this.state.filterTaskClosed}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Tous</option>
                      <option value={0}>Ouvert</option>
                      <option value={1}>Clôs</option>
                    </select>
                  </th>
                  <th className='cursor' onClick={() => this.toggleDateFiltering('filterTaskDate')}>
                    Date Limite{' '}
                    <span className={'icon icon-triangle-' + (this.state.filterTaskDate ? 'down ' : 'up ')} />
                  </th>
                  <th>
                    <select
                      name='filterTaskCriticity'
                      value={this.state.filterTaskCriticity}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Criticité</option>
                      {Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>
                    <select
                      name='filterTaskPriority'
                      value={this.state.filterTaskPriority}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Priorité</option>
                      {Object.entries(data_priority).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>Supprimer</th>
                </tr>
              </thead>
              <tbody>
                {dataTask ? (
                  this.filterTasks(dataTask)
                    .sort((a, b) =>
                      this.state.filterTaskDate
                        ? new Date(b.deadline) - new Date(a.deadline)
                        : new Date(a.deadline) - new Date(b.deadline)
                    )
                    .map((data, i) => (
                      <tr
                        key={i}
                        className={
                          '' +
                          (this.isCollaborativeNegative('task', data.deadline, data.closed, data.state)
                            ? 'marked-negative  '
                            : this.isCollaborativePositive('task', data.deadline, data.closed, data.state)
                            ? 'marked-positive '
                            : '')
                        }
                      >
                        <td>
                          <Link to={linkToTask + data.id}>
                            <span>{data.title}</span>
                          </Link>
                        </td>
                        <td>
                          <span>{data.closed ? 'clôs' : 'Ouvert'}</span>
                        </td>
                        <td>
                          <span>{moment(data.deadline).format('DD-MM-YY | HH:mm')}</span>
                        </td>
                        <td>
                          <span>{data.criticity + '-' + data_criticity[data.criticity].fr}</span>
                        </td>
                        <td>
                          <span>{data.priority + '-' + data_priority[data.priority].fr}</span>
                        </td>
                        <td>
                          <button
                            onClick={(id, type) => this.props.deleteCollaborative(data.id, 'task')}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross' />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
              </tbody>
            </table>
            {this.props.hasMoreTask && (
              <div className='list-see-more'>
                {this.props.pendingHasMoreTask ? (
                  <img src={ringAnim} alt='' />
                ) : (
                  <button onClick={() => this.seeMore('task')} type='button' className='btn btn-sm btn-outline-success'>
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
            {noTask}
          </div>
        )}

        {this.state.selectedView === 2 && (
          <div>
            <div className='helper helper-panel-legend'>
              <span className='helper-label-legend lvl2'>Passé</span>
              <span className='helper-label-legend lvl1'>
                À venir <i>(dans moins de 48h)</i>
              </span>
            </div>
            <br />

            <table className='table'>
              <thead>
                <tr>
                  <th>Titre</th>
                  <select
                    name='filterAppointmentClosed'
                    value={this.state.filterAppointmentClosed}
                    onChange={this.handleInputChange}
                    className='select-stock-search form-control'
                  >
                    <option value={-1}>Tous</option>
                    <option value={0}>Non-effectué</option>
                    <option value={1}>Effectué</option>
                  </select>
                  <th className='cursor' onClick={() => this.toggleDateFiltering('filterAppointmentDate')}>
                    Date rdv{' '}
                    <span className={'icon icon-triangle-' + (this.state.filterAppointmentDate ? 'down ' : 'up ')} />
                  </th>
                  <th>
                    <select
                      name='filterAppointmentCriticity'
                      value={this.state.filterAppointmentCriticity}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Criticité</option>
                      {Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>Supprimer</th>
                </tr>
              </thead>
              <tbody>
                {dataAppointment ? (
                  this.filterAppointments(dataAppointment)
                    .sort((a, b) =>
                      this.state.filterAppointmentDate
                        ? new Date(b.dateMeeting) - new Date(a.dateMeeting)
                        : new Date(a.dateMeeting) - new Date(b.dateMeeting)
                    )
                    .map((data, i) => (
                      <tr
                        key={i}
                        className={
                          '' +
                          (this.isCollaborativeNegative('appointment', data.dateMeeting, data.closed)
                            ? 'marked-negative  '
                            : this.isCollaborativePositive('appointment', data.dateMeeting, data.closed)
                            ? 'marked-positive '
                            : '')
                        }
                      >
                        <td>
                          <Link to={linkToAppointment + data.id}>
                            <span>{data.title}</span>
                          </Link>
                        </td>
                        <td>
                          <span>{data.closed ? 'Effectué' : 'Non-effectué'}</span>
                        </td>
                        <td>
                          <span>{moment(data.dateMeeting).format('DD-MM-YY | HH:mm')}</span>
                        </td>
                        <td>
                          <span>{data.criticity + '-' + data_criticity[data.criticity].fr}</span>
                        </td>
                        <td>
                          <button
                            onClick={(id, type) => this.props.deleteCollaborative(data.id, 'appointment')}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross' />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
              </tbody>
            </table>
            {this.props.hasMoreAppointment && (
              <div className='list-see-more'>
                {this.props.pendingHasMoreAppointment ? (
                  <img src={ringAnim} alt='' />
                ) : (
                  <button
                    onClick={() => this.seeMore('appointment')}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
            {noAppointment}
          </div>
        )}

        {this.state.selectedView === 3 && (
          <div>
            <div className='helper helper-panel-legend'>
              <span className='helper-label-legend lvl2'>À traiter</span>
              <span className='helper-label-legend lvl1'>En cours</span>
            </div>
            <br />

            <table className='table'>
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>
                    <select
                      name='filterReminderClosed'
                      value={this.state.filterReminderClosed}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Tous</option>
                      <option value={0}>Ouvert</option>
                      <option value={1}>Clôs</option>
                    </select>
                  </th>
                  <th className='cursor' onClick={() => this.toggleDateFiltering('filterReminderDate')}>
                    Date rappel{' '}
                    <span className={'icon icon-triangle-' + (this.state.filterReminderDate ? 'down ' : 'up ')} />
                  </th>
                  <th>
                    <select
                      name='filterReminderCriticity'
                      value={this.state.filterReminderCriticity}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                    >
                      <option value={-1}>Criticité</option>
                      {Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>Supprimer</th>
                </tr>
              </thead>
              <tbody>
                {dataReminder ? (
                  this.filterReminders(dataReminder)
                    .sort((a, b) =>
                      this.state.filterReminderDate
                        ? new Date(b.dateRecall) - new Date(a.dateRecall)
                        : new Date(a.dateRecall) - new Date(b.dateRecall)
                    )
                    .map((data, i) => (
                      <tr
                        key={i}
                        className={
                          '' +
                          (this.isCollaborativeNegative('reminder', data.dateRecall, data.closed, data.state)
                            ? 'marked-negative  '
                            : this.isCollaborativePositive('reminder', data.dateRecall, data.closed, data.state)
                            ? 'marked-positive '
                            : '')
                        }
                      >
                        <td>
                          <Link to={linkToReminder + data.id}>
                            <span>{data.title}</span>
                          </Link>
                        </td>
                        <td>
                          <span>{data.closed ? 'clôs' : 'Ouvert'}</span>
                        </td>
                        <td>
                          <span>{moment(data.dateRecall).format('DD-MM-YY | HH:mm')}</span>
                        </td>
                        <td>
                          <span>{data.criticity + '-' + data_criticity[data.criticity].fr}</span>
                        </td>
                        <td>
                          <button
                            onClick={(id, type) => this.props.deleteCollaborative(data.id, 'reminder')}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross' />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
                {noReminder}
              </tbody>
            </table>
            {this.props.hasMoreReminder && (
              <div className='list-see-more'>
                {this.props.pendingHasMoreReminder ? (
                  <img src={ringAnim} alt='' />
                ) : (
                  <button
                    onClick={() => this.seeMore('reminder')}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        {this.state.selectedView === 4 && (
          <div>
            <table className='table'>
              <thead>
                <tr>
                  <th>Titre</th>
                  <th className='cursor' onClick={() => this.toggleDateFiltering('filterNoteDate')}>
                    Créé le <span className={'icon icon-triangle-' + (this.state.filterNoteDate ? 'down ' : 'up ')} />
                  </th>
                  <th>Supprimer</th>
                </tr>
              </thead>
              <tbody>
                {dataNote ? (
                  dataNote
                    .sort((a, b) =>
                      this.state.filterNoteDate
                        ? new Date(b.dateCreate) - new Date(a.dateCreate)
                        : new Date(a.dateCreate) - new Date(b.dateCreate)
                    )
                    .map((data, i) => (
                      <tr key={i}>
                        <td>
                          <Link to={linkToNote + data.id}>
                            <span>{data.title}</span>
                          </Link>
                        </td>
                        <td>
                          <span>{moment(data.dateCreate).format('DD-MM-YY | HH:mm')}</span>
                        </td>
                        <td>
                          <button
                            onClick={(id, type) => this.props.deleteCollaborative(data.id, 'note')}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross' />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
              </tbody>
            </table>
            {this.props.hasMoreNote && (
              <div className='list-see-more'>
                {this.props.pendingHasMoreNote ? (
                  <img src={ringAnim} alt='' />
                ) : (
                  <button onClick={() => this.seeMore('note')} type='button' className='btn btn-sm btn-outline-success'>
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
            {noNote}
          </div>
        )}
      </div>
    );
  }

  switchStep(newStep) {
    this.setState({
      selectedView: newStep,
    });
  }
}
